var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83321 3.74033C4.37987 5.72699 6.66654 8.66699 6.66654 8.66699V12.0003C6.66654 12.7337 7.26654 13.3337 7.99987 13.3337C8.73321 13.3337 9.33321 12.7337 9.33321 12.0003V8.66699C9.33321 8.66699 11.6199 5.72699 13.1665 3.74033C13.5065 3.30033 13.1932 2.66699 12.6332 2.66699H3.35987C2.80654 2.66699 2.49321 3.30033 2.83321 3.74033Z",
    fill: "#21005D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.0834cd413efb30fbd1498bbbb8a43fc0.svg";
export { ForwardRef as ReactComponent };